import Base from "./base.service.js";
import Vue from "vue";
export default class RepairReason extends Base {
    constructor() {
        super("repair-reason");
    }

    getRepairReasons() {
        return new Promise(resolve => {
            Vue.axios
                .get(this.path + "?page=1&hidden=true&limit=100000")
                .then(res => {
                    return resolve(res.data.data.docs);
                })
                .catch(() => {
                });
        });
    }
}
